// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071106/js/" + chunkId + "." + {"44":"8a201c96","225":"b034e7ce","481":"c0a9f918","486":"53c47324","770":"687a24f7"}[chunkId] + ".0.47226945764678485.chunk.js";
};